import { useMemo } from "react"
import { useLocation } from "react-router-dom"
import { parseQuery } from "utils/parseQuery"

export const useCurrentId = () => {
  const location = useLocation()

  return useMemo(() => parseQuery(location.search).id, [location.search])
}
